import { EntityRepository } from 'root/lsCloud/EntityRepository/EntityRepository';

export class UserPreferenceRepository extends EntityRepository {
  constructor() {
    super('UserPreference');
  }

  getPath() {
    return `/API/Account/${this.getAccountID()}/UserPreference.json?employeeID=${this.getEmployeeID()}`;
  }

  get(
    preferenceType: string,
    preferenceComponent: string,
    preferenceName: string,
    options: { reload?: boolean } = {}
  ): JQuery.Deferred<string | undefined> {
    const deferred = $.Deferred();
    this.getAll(options)
      .then((preferences) => {
        const preference = preferences.find((preference) => {
          return (
            preference.type === preferenceType &&
            preference.component === preferenceComponent &&
            preference.name === preferenceName
          );
        });
        deferred.resolve(preference?.value);
      })
      .catch(() => deferred.reject());
    return deferred;
  }

  save(
    preferenceType: string,
    preferenceComponent: string,
    preferenceName: string,
    preferenceValue: string
  ): JQuery.Deferred<void> {
    const deferred = $.Deferred();
    let cached: boolean = false;

    if (this.entities !== null) {
      cached = this.entities.some((entity, index) => {
        if (
          entity.type === preferenceType &&
          entity.component === preferenceComponent &&
          entity.name === preferenceName
        ) {
          this.entities![index].value = preferenceValue;
          return true;
        }
        return false;
      });
    }

    try {
      const url: string = this.getPath();
      const userPreference = {
        type: preferenceType,
        component: preferenceComponent,
        name: preferenceName,
        value: preferenceValue,
      };
      const obj = { UserPreference: [userPreference] };
      const type = 'POST';
      const job: LSCloudServerJob = { url, obj, type };
      window.lsCloud
        .startServerJob(job)
        .done((response) => {
          if (this.entities && !cached) {
            this.entities.push(response.UserPreference);
          }
          deferred.resolve();
        })
        .fail((error) => deferred.reject(error));
    } catch (error) {
      deferred.reject(error);
    }
    return deferred;
  }

  async bulkSave(preferences: LsCloudUserPreferenceDTO[]): Promise<void> {
    if (preferences.length === 0) {
      return;
    }
    try {
      const url: string = this.getPath();
      const obj = { UserPreference: preferences };
      const type = 'POST';
      const job: LSCloudServerJob = { url, obj, type };
      const updatedUserPreferences = await window.lsCloud.startServerJob(job).promise();

      if (this.entities !== null && updatedUserPreferences?.UserPreference) {
        if (!Array.isArray(updatedUserPreferences.UserPreference)) {
          updatedUserPreferences.UserPreference = [updatedUserPreferences.UserPreference];
        }
        updatedUserPreferences.UserPreference.forEach(
          (updatedUserPreference: LsCloudUserPreferenceDTO) => {
            const index = this.entities!.findIndex((entity) => {
              return (
                entity.type === updatedUserPreference.type &&
                entity.component === updatedUserPreference.component &&
                entity.name === updatedUserPreference.name
              );
            });
            if (index !== -1) {
              this.entities![index].value = updatedUserPreference.value;
            } else {
              this.entities!.push(updatedUserPreference);
            }
          }
        );
      }
    } catch (error) {
      throw error;
    }
  }
}
